/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoIdentificacion from 'Infotrack@Modelos/administracion/tipoIdentificacion/entidades/tipoIdentificacion';
import React from 'react';
import TipoIdentificacionCM from '../controladorModelo/tipoIdentificacionCM';
import { acciones, IEstadoTipoIdentificacion } from '../reductorTipoIdentificacion';
import FormularioTipoIdentificacionVista from '../vista/formularioTipoIdentificacionVista';

const estadoInicial: ITipoIdentificacion = {
    Abreviatura: '',
    CodigoTipoIdentificacion: '',
    DescripcionTipoIdentificacion: '',
    IdTipoIdentificacion: 0,
    Estado: true,
};
const tipoIdentificacionCM = new TipoIdentificacionCM();

const FormularioTipoIdentificacionCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadTipoIdentificacion }, dispatch] = useProveedor<
        IEstadoTipoIdentificacion
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITipoIdentificacion>(estadoInicial);

    React.useEffect(() => {
        if (entidadTipoIdentificacion && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTipoIdentificacion);
        } else {
            reiniciar();
        }
    }, [entidadTipoIdentificacion]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };

    const confirmarCreacionEdicionTipoIdentificacion = () => {
        if (tipoIdentificacionCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTipoIdentificacion,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTipoIdentificacion = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tipoIdentificacionCM.crearTipoIdentificacion(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            tipoIdentificacionCM.editarTipoIdentificacion(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioTipoIdentificacionVista
            accionCrearEditar={confirmarCreacionEdicionTipoIdentificacion}
            cambiarInfoFomulario={alCambiarValor}
            tipoIdentificacion={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioTipoIdentificacionCV;
